import React, { useEffect } from 'react';
import { Global } from '@emotion/react';
import {
  ChakraProvider,
  ChakraProviderProps,
  extendTheme,
} from '@chakra-ui/react';

import { reset } from './reset';
import { theme } from './theme';

interface Props extends ChakraProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider = ({ children }: Props): JSX.Element => {
  useEffect(() => {
    const head = document.querySelector(`head`);

    const googleLink = document.createElement<'link'>(`link`);

    googleLink.rel = `preconnect`;
    googleLink.href = `https://fonts.gstatic.com`;

    const fontLink = document.createElement<'link'>(`link`);

    fontLink.href = `https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap`;
    fontLink.rel = `stylesheet`;

    head?.appendChild(googleLink);
    head?.appendChild(fontLink);
  }, []);

  return (
    <ChakraProvider theme={extendTheme(theme)}>
      <Global styles={reset} />
      {children}
    </ChakraProvider>
  );
};
